module.exports = __webpack_public_path__ + "img/cloud-download.86fd978f.svg";